import {
  Typography,
  Box,
  Button,
  Grid,
  Select,
  MenuItem,
  Divider,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import useStyles from "./ReviewAgentModal.styles";
import { CaretLeft, CheckSquareOffset } from "phosphor-react";

const ToDoTaskUpdation = ({ goBack }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.spaceBetween}>
        <Typography>
          <span className={classes.greyText}>Tasks linked</span> : 2
        </Typography>
        <Typography>
          <span className={classes.greyText}>New To Do's</span> : 12
        </Typography>
      </Box>
      <Box className={classes.listContainer}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Typography className={classes.biggerText}>
              <CheckSquareOffset size={22} />
              Relace Animation
            </Typography>
            <Select
              value={"none"}
              disableUnderline={true}
              className={classes.select}
            >
              <MenuItem value={"none"}>None</MenuItem>
            </Select>
          </Grid>
          <Grid
            item
            xs={5}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography align="center" className={classes.mediumText}>
              <span className={classes.greyText}>To Do's </span> 2
            </Typography>
            <div className={classes.select}>
              <Typography className={classes.purpleText}>From</Typography>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  autoOk
                  invalidDateMessage={"inValid"}
                  variant="inline"
                  format="yyyy/MM/DD"
                  // value={startDate}
                  // onChange={(date) => handleStartDateChange(new Date(date))}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      paddingTop: "5px",
                      fontSize: "12px",
                      width: "155px",
                    },
                  }}
                  className={classes.input}
                  id="Startdate-picker"
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  size="small"
                  fullWidth={false}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
          <Grid item xs={4}>
            <Typography className={classes.mediumText}>
              <span className={classes.greyText}>Estimated Duration </span> 1
              day 1 hour
            </Typography>
            <div className={classes.select}>
              <Typography className={classes.purpleText}>To</Typography>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  autoOk
                  invalidDateMessage={"inValid"}
                  variant="inline"
                  format="yyyy/MM/DD"
                  // value={startDate}
                  // onChange={(date) => handleStartDateChange(new Date(date))}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      paddingTop: "5px",
                      fontSize: "12px",
                      width: "155px",
                    },
                  }}
                  className={classes.input}
                  id="Startdate-picker"
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  size="small"
                  fullWidth={false}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Grid>
        </Grid>
        <Divider style={{ margin: "16px 0px" }} />
      </Box>
      <Box className={classes.btnContainer}>
        <Button
          onClick={goBack}
          className={classes.outlinedBtn}
          startIcon={<CaretLeft />}
        >
          Back
        </Button>
        <Button className={classes.submitButton}>
          Add To Do’s & update Tasks
        </Button>
      </Box>
    </>
  );
};

export default ToDoTaskUpdation;
